import { render, staticRenderFns } from "./AppMaster.vue?vue&type=template&id=f42dcea0"
import script from "./AppMaster.vue?vue&type=script&lang=js"
export * from "./AppMaster.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports